<template>
    <SbsBaseButton
        v-bind="$attrs"
        class="sbs-button-info trs"
        :class="buttonInfoClasses"
        :to="to">
        <!-- @slot Слот по-умолчанию -->
        <slot>
            <div
                v-if="title || subtitle"
                class="sbs-button-info__info">
                <p
                    v-if="title"
                    class="sbs-button-info__page-name">
                    {{ title }}
                </p>

                <p
                    v-if="subtitle"
                    class="sbs-button-info__stream-name"
                    :title="subtitle">
                    {{ subtitle }}
                </p>
            </div>
        </slot>

        <!-- @slot Слот для иконки -->
        <slot name="icon">
            <SbsIcon
                class="sbs-button-info__icon"
                v-bind="iconData" />
        </slot>
    </SbsBaseButton>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { AllColors } from '../../utils/colors.js';
import { AllSizes } from '../../utils/sizes.js';

/**
 * Кнопка с информацией
 */
export default {
    name: 'SbsButtonInfo',
    mixins: [themesMixin],
    computed: {
        buttonInfoClasses() {
            return [
                ...this.themeClasses,
                {
                    'full-width': this.fullWidth,
                    'disabled': this.disabled,
                },
            ];
        },
        iconData() {
            return {
                iconName: 'arrow-right',
                iconSize: AllSizes.LARGE,
                backgroundTheme: AllColors.WHITE,
                width: 40,
                height: 40,
            };
        },
    },
    inheritAttrs: false,
    props: {
        // eslint-disable-next-line vue/no-unused-properties
        backgroundTheme: {
            type: String,
            default: AllColors.GRAY_ULTRA_LIGHT,
        },
        /**
         * Отключает взаимодействие с компонентом
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Растягивает компонент на всю ширину родителя
         */
        fullWidth: {
            type: Boolean,
            default: false,
        },
        /**
         * Подзаголовок
         */
        subtitle: {
            type: String,
            default: '',
        },
        /**
         * Заголовок
         */
        title: {
            type: String,
            default: '',
        },
        /**
         * Роут для `<RouterLink>` для перехода на другую страницу без перезагрузки.
         * Может быть строкой, либо объектом.
         * Имеет более высокий приоритет перед `href`
         */
        to: {
            type: [Object, String],
            default: null,
        },
    },
};
</script>

<style lang="scss">
.sbs-button-info {
    display: flex;
    align-items: center;
    max-width: 100%;
    padding: 15px;
    border-radius: $rounded-10;

    &.full-width {
        width: 100%;
    }

    &.disabled {
        opacity: 0.5;
    }

    &__info {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        margin-right: 45px;
        overflow: hidden;
        text-align: left;
    }

    &__page-name {
        word-wrap: break-word;

        @include reset-p;
        @include typo-secondary-book;

        &:not(:only-child) {
            margin-bottom: 5px;
        }
    }

    &__stream-name {
        color: $gray-deep;

        @include text-clamp;
        @include reset-p;
        @include typo-subsecondary-demi;
    }

    &__icon {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        border-radius: $rounded-circle;
    }
}
</style>
